import { createContext, useContext, useState, useEffect } from 'react';

const AppContext = createContext();

export function AppProvider({ children }) {
  const [theme, setTheme] = useState(() => localStorage.getItem('w3pitch-theme') || 'dark');
  const [pitches, setPitches] = useState(() => {
    try { return JSON.parse(localStorage.getItem('w3pitch-pitches') || '[]'); } catch { return []; }
  });

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('w3pitch-theme', theme);
  }, [theme]);

  useEffect(() => {
    localStorage.setItem('w3pitch-pitches', JSON.stringify(pitches));
  }, [pitches]);

  const toggleTheme = () => setTheme(t => t === 'dark' ? 'light' : 'dark');

  const addPitch = (pitch) => {
    const entry = { ...pitch, id: Date.now(), createdAt: new Date().toISOString(), status: 'sent' };
    setPitches(prev => [entry, ...prev]);
    return entry;
  };

  const updatePitch = (id, updates) => {
    setPitches(prev => prev.map(p => p.id === id ? { ...p, ...updates } : p));
  };

  const deletePitch = (id) => setPitches(prev => prev.filter(p => p.id !== id));

  const stats = {
    total: pitches.length,
    sent: pitches.filter(p => p.status === 'sent').length,
    replied: pitches.filter(p => p.status === 'replied').length,
    closed: pitches.filter(p => p.status === 'closed').length,
    skipped: pitches.filter(p => p.status === 'skip').length,
    replyRate: pitches.length > 0
      ? Math.round((pitches.filter(p => ['replied','closed'].includes(p.status)).length / pitches.length) * 100)
      : 0,
    closeRate: pitches.filter(p => ['replied','closed'].includes(p.status)).length > 0
      ? Math.round((pitches.filter(p => p.status === 'closed').length / pitches.filter(p => ['replied','closed'].includes(p.status)).length) * 100)
      : 0,
    earned: pitches.filter(p => p.status === 'closed').reduce((sum, p) => sum + (Number(p.amount) || 0), 0),
  };

  return (
    <AppContext.Provider value={{ theme, toggleTheme, pitches, addPitch, updatePitch, deletePitch, stats }}>
      {children}
    </AppContext.Provider>
  );
}

export const useApp = () => useContext(AppContext);
